/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import { API_URL, BASE_URL } from "../constants";
import { logout } from ".";
const axios = require("axios");

export function setCookie(name, value, time) {
  var expires = "";
  if (time) {
    var date = new Date();
    date.setTime(date.getTime() + time * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    // eslint-disable-next-line eqeqeq
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
export function eraseCookie(name) {
  setCookie(name, "", 1);
}

export function getLocalStorage(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    // eslint-disable-next-line eqeqeq
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function getAccessToken() {
  return new Promise((resolve) => {
    let refresh_token = getCookie("refresh_token");
    //console.log("refresh_token",refresh_token);
    var auth = {
      auth: {
        username: "web",
        password: "web",
      },
    };
    var loginUrl = `${API_URL}oauth/token?grant_type=refresh_token&refresh_token=${refresh_token}`;
    axios
      .post(loginUrl, {}, auth)
      .then(async (response) => {
        //console.log("response",response)
        let resp = await resetAccessToken(response);
        if (resp) {
          resolve(true);
        }
      })
      .catch(async (err, code) => {
        logout();
      });
  });
}

export function resetAccessToken(response) {
  return new Promise((resolve) => {
    if (response.status === 200) {
      setCookie(
        "access_token",
        response.data.access_token,
        response.data.expires_in
      );
      setCookie(
        "token_type",
        response.data.token_type,
        response.data.expires_in
      );
      setCookie("refresh_token", response.data.refresh_token);
      setCookie(
        "expires_in",
        response.data.expires_in,
        response.data.expires_in
      );
      resolve(true);
    } else {
      logout();
    }
  });
}
